import React from 'react'

interface Props {
  sponsor: {
    companyName: string
    companyLogoUrl?: string | null
  }
}

const CompanySponsor: React.FC<Props> = ({ sponsor }) => {
  const { companyName, companyLogoUrl } = sponsor

  return (
    <div className="flex flex-col items-center gap-12">
      <aside className="flex flex-col gap-1 text-center">
        <div className="font-medium">Introduced by:</div>

        {companyLogoUrl ? (
          <img
            style={{ maxWidth: '100px', maxHeight: '100px' }}
            className="max-w-full"
            src={companyLogoUrl}
            alt={companyName}
          />
        ) : (
          <div className="px-1 text-lg">{companyName}</div>
        )}
      </aside>
    </div>
  )
}

export default CompanySponsor
